module.exports={
    "两次输入的密码必须一致": "Passwords should match",
    "取消": "Cancel",
    "如验证出现问题，请点击": "Verification Problem",
    "如验证出现问题，请联系orcalivecs@asiainnovations.com": "If verification error occurs, please contact orcalivecs@asiainnovations.com",
    "如验证出现问题，请联系upcs@asiainnovations.com": "If verification error occurs, please contact upcs@asiainnovations.com",
    "密码修改成功": "Password changed sucessfully!",
    "密码格式错误": "Wrong format",
    "密码由6-20位由数字和字母组成": "Password must contains letter and number of 6-20 characters in length",
    "恭喜您密码重置成功": "Password reset sucessfully!",
    "恭喜您已成功激活帐户": "You have activated your account!",
    "知道了": "OK",
    "确认修改": "Confirm modification",
    "网络连接有误, 请稍后再试": "Connection problem, please retry later",
    "联系客服": "Customer Support",
    "请再次输入密码": "Confirm password",
    "请返回UpVoice中重新进行邮箱验证": "Back to UpVoice to email verify",
    "请返回Up直播中重新进行邮箱验证": "Back to Uplive to email verify",
    "请返回虎鲸直播中重新进行邮箱验证": "Back to Orcalive to email verify",
    "请重新设定登录密码": "Reset password",
    "请重新设置密码": "Reset password",
    "赶快返回UpVoice中与全球潮人互动吧": "Back to UpVoice, and let's party!",
    "赶快返回Up直播中与全球潮人互动吧！": "Back to Uplive, and let's party!",
    "赶快返回虎鲸直播中与全球潮人互动吧": "Back to Orcalive, and let's party!",
    "重置密码失败": "Fail to reset password",
    "验证失败": "Verification failed",
    "验证成功": "Verification success!"
};


// WEBPACK FOOTER //
// ./js/lang/msmy.js